export default __webpack_public_path__ + "static/media/boxtype7.ea143e68.JPG";